var map = {
	"./sos-type-black.png": "9abb",
	"./sos-type-blue.png": "d1d4",
	"./sos-type-brown.png": "16b8",
	"./sos-type-green.png": "6ee1",
	"./sos-type-grey.png": "f66c",
	"./sos-type-orange.png": "4919",
	"./sos-type-pink.png": "603c",
	"./sos-type-purple.png": "f76b",
	"./sos-type-red.png": "216f",
	"./sos-type-silver.png": "e4b0",
	"./sos-type-white.png": "0a03",
	"./sos-type-yellow.png": "c4b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f45";